<template>
  <UnauthorizedComponent @updateLanguage="updateLanguage" :languagestrings="languagestrings" :toperror="toperror" />
</template>

<script>
  import UnauthorizedComponent from '../components/UnauthorizedComponent';

  export default {
    name: 'UnauthorizedView',

    components: {
      UnauthorizedComponent,
    },

    props: ['languagestrings', 'toperror'],
    
    methods: {
      updateLanguage(language) {
        this.$emit("updateLanguage", language);
      }
    },

    created: function(){
    }
  }
</script>
